module.exports = __webpack_public_path__ + "static/about_simulator_cube_art@2x-da9dd5012c74f2d1cdd95cd9a744a5e8.png";